import { render, staticRenderFns } from "./ItemAccountList.vue?vue&type=template&id=40b2e976"
import script from "./ItemAccountList.vue?vue&type=script&lang=js"
export * from "./ItemAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports